"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var states_1 = require("../../../../common/constants/states");
var json_1 = require("../../../../common/helpers/json");
var time_1 = require("../../../../common/helpers/time");
var AdminInstructorCreate = /** @class */ (function () {
    function AdminInstructorCreate($rootScope, UserService, $state, UsersModel, FlashService) {
        var _this = this;
        this.loading = true;
        this.$rootScope = $rootScope;
        this.UserService = UserService;
        this.$state = $state;
        this.UsersModel = UsersModel;
        this.FlashService = FlashService;
        this.user = UserService.getCurrentUser();
        this.school = this.user.school;
        this.school.address = (0, json_1.isJson)(this.user.school.address)
            ? JSON.parse(this.user.school.address)
            : this.user.school.address;
        this.section = "contactInfo";
        this.states = states_1.States;
        this.formData = {
            school_id: this.school.id,
            usertype_id: 3,
        };
        $rootScope.$on("MESSAGE_CLEARED", function () {
            _this.submitted = false;
        });
    }
    AdminInstructorCreate.prototype.createInstructor = function () {
        var _this = this;
        this.submitted = true;
        var data = Object.assign({}, this.formData);
        if (!data.usermeta.address || !data.usermeta.address.street) {
            delete data.usermeta.address;
        }
        if (!data.usermeta.address || !data.usermeta.address.street) {
            delete data.usermeta.address;
        }
        if (data.usermeta && data.usermeta.employment_start_date) {
            data.usermeta.employment_start_date = (0, time_1.formatDisplayForYmd)(data.usermeta.employment_start_date);
        }
        this.UsersModel.createInstructor(data)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.formData = {
                school_id: _this.school.id,
                usertype_id: 3,
            };
            _this.submitted = false;
            _this.$state.go("drivecoach.admin.instructors.index", {}, { reload: true });
        })
            .catch(function (Error) {
            _this.submitted = false;
        });
    };
    return AdminInstructorCreate;
}());
AdminInstructorCreate.$inject = [
    "$rootScope",
    "UserService",
    "$state",
    "UsersModel",
    "FlashService",
];
exports.default = AdminInstructorCreate;
